import { useFormikSubmit } from "@certn/api";
import {
  BasicButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  PrimaryButton,
  TextInputFormikField,
} from "@certn/cascadia-react";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { APIKeyWithNameAndID } from "./types";

interface Props {
  isOpen: boolean;
  apiKey: APIKeyWithNameAndID;
  onOpenChange(isOpen: boolean): void;
  onSuccess(): void;
}

export function EditAPIKeyModal({
  isOpen,
  onOpenChange,
  onSuccess,
  apiKey,
}: Props) {
  const { t } = useTranslation();

  const { submit, isSubmitting } = useFormikSubmit(
    `/api/internal/client-portal/public-api/api-keys/${apiKey.id}/edit/`,
    {
      onSuccess,
      showToastOnError: true,
    }
  );

  return (
    <Modal
      testID="edit-api-key-modal"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <Dialog>
        <Formik<{ name?: string }>
          initialValues={{
            name: apiKey.name,
          }}
          onSubmit={submit}
        >
          <Form>
            <DialogHeader onClose={() => onOpenChange(false)}>
              {t("Edit API key name")}
            </DialogHeader>
            <DialogContent>
              <TextInputFormikField
                label={t("API key name")}
                testID="api-key-name"
                name="name"
                isRequired
              />
            </DialogContent>
            <DialogFooter>
              <BasicButton
                onPress={() => onOpenChange(false)}
                testID="cancel"
                isDisabled={isSubmitting}
              >
                {t("Cancel")}
              </BasicButton>
              <PrimaryButton
                testID="save-changes"
                type="submit"
                isDisabled={isSubmitting}
              >
                {t("Save changes")}
              </PrimaryButton>
            </DialogFooter>
          </Form>
        </Formik>
      </Dialog>
    </Modal>
  );
}
